// ============================================================
// Platform Control · Projects view — admin-flavored projection
// of the portfolio. Distinct from /square/projects: this is the
// platform's view of provisioning state, not the user's view of
// project work. Reads from usePlatformProjects().
// ============================================================

import { useNavigate } from 'react-router-dom'
import { usePlatformProjects } from '../../../hooks/usePlatformProjects'
import EmptyState from '../../../components/EmptyState'
import { SHELL_TOKENS } from '../../../shell/styles'
import ViewShell, { Section } from './_ViewShell'

export default function PlatformProjectsView() {
  const navigate = useNavigate()
  const { projects, loading } = usePlatformProjects()

  return (
    <ViewShell
      kicker="PLATFORM CONTROL · PROJECTS"
      title="Projects"
      description="Operator view of every project: tier, region, last deploy. Distinct from the user-facing portfolio."
    >
      <Section label="PORTFOLIO">
        {loading ? (
          <EmptyState title="Loading" body="Hydrating platform projections." />
        ) : projects.length === 0 ? (
          <EmptyState title="No projects" body="None provisioned yet." />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {projects.map((p) => (
              <button
                key={p.id}
                type="button"
                onClick={() => navigate(`/square/projects/${p.id}`)}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1.4fr 0.8fr 0.8fr 1fr',
                  alignItems: 'center',
                  gap: 8,
                  padding: '12px 14px',
                  borderRadius: 10,
                  background: SHELL_TOKENS.surface,
                  border: `1px solid ${SHELL_TOKENS.border}`,
                  color: SHELL_TOKENS.ink,
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontFamily: 'inherit',
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 700, color: '#c0c8d2' }}>
                  {p.name}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: SHELL_TOKENS.inkMuted,
                    fontFamily: 'var(--font-mono)',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                  }}
                >
                  tier: {p.tier}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: SHELL_TOKENS.inkMuted,
                    fontFamily: 'var(--font-mono)',
                  }}
                >
                  region: {p.region ?? '—'}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: SHELL_TOKENS.inkMuted,
                    fontFamily: 'var(--font-mono)',
                    textAlign: 'right',
                  }}
                >
                  deploy: {p.last_deploy_at ?? 'never'}
                </div>
              </button>
            ))}
          </div>
        )}
      </Section>
    </ViewShell>
  )
}
